<div class="alert alert-danger" role="alert" *ngIf="data?.is_suspended == 1"><strong>Account suspended.</strong> Top-up, withdrawal and agent actions are unavailable.</div>
<fieldset class="border-0 p-0 m-0 w-100" [disabled]="data?.is_suspended == 1" [attr.inert]="data?.is_suspended == 1 ? '' : null">
<ng-container *ngIf="is_loading">
    <div class="d-flex flex-row">
        <div class="loader"></div>&nbsp;<span>Loading Player...</span>
    </div>
</ng-container>
<div class="row" *ngIf="!is_loading">
    <div class="col-md-12 mb-4">
        <app-player-transaction-history [all]="true" [setPlaterUUID]="player_uuid"
            [setHistoryType]="initial_tab"></app-player-transaction-history>
    </div>
    <div class="col-md-3">
        <div class="card mb-3">
            <div class="card-header">
                <h2 class="card-title mb-0">Player Information</h2>
            </div>
            <div class="card-body">
                <table class="table table-striped table-sm mb-0">
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <td>{{data.name}}</td>
                        </tr>
                        <tr>
                            <th>Code</th>
                            <td>{{data.code}}</td>
                        </tr>
                        <tr>
                            <th>Mobile</th>
                            <td>
                                {{data.mobile}} <em>*</em><br />
                                <ng-container *ngFor="let m of data.mobiles; let i =index">
                                    {{m.mobile}}<br />
                                </ng-container>
                            </td>
                        </tr>
                        <tr>
                            <th>DOB</th>
                            <td>{{data.dob}}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Bank</th>
                        </tr>
                        <tr *ngFor="let bank of data.banks">
                            <td colspan="2">{{bank.bank}} - {{bank.account}}</td>
                        </tr>
                        <tr>
                            <th>Status</th>
                            <td>{{data.status ? 'Active' : 'Disabled'}}</td>
                        </tr>
                        <tr>
                            <th>Can Login</th>
                            <td>{{data.can_login ? 'Yes' : 'No'}}</td>
                        </tr>
                        <tr>
                            <th colspan="2" class="bg-dark text-dark">Summary</th>
                        </tr>
                        <tr>
                            <th>Wallet Balance</th>
                            <td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(data.wallet ?
                                    data.wallet : 0) | number: '1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <th>Total Topup</th>
                            <td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.topup ?
                                    summary.topup : 0) | number: '1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <th>Total Withdraw</th>
                            <td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.withdraw
                                    ? summary.withdraw : 0) | number: '1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <th>Total Profit</th>
                            <td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.profit ?
                                    summary.profit : 0) | number: '1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <th>Total Tips</th>
                            <td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.tips ?
                                    summary.tips : 0) | number: '1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <th>Total Bonus</th>
                            <td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.bonus ?
                                    summary.bonus : 0) | number: '1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <th>Total Point</th>
                            <td class="d-flex flex-row justify-content-between"><span class="ms-auto">{{(summary.point ?
                                    summary.point : 0) | number: '1.2-2'}}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card-header d-flex flex-row justify-content-between align-items-center">
                <h2 class="card-title mb-0">Player Game ID</h2>
                <button class="btn btn-outline-dark rounded-5 btn-sm" *ngIf="!deletePlayerEnabled"
                    (click)="enabledDeleteOfPlayer()">Manage ID</button>
                <button *ngIf="deletePlayerEnabled" class="btn btn-sm btn-danger"
                    (click)="deletePlayerID()">Delete</button>
            </div>
            <div class="card-body p-0">
                <table class="table table-striped table-sm mb-0">
                    <tbody>
                        <tr>
                            <th *ngIf="deletePlayerEnabled"></th>
                            <th>Game</th>
                            <th>ID</th>
                            <th>Game Balance</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                        <tr *ngFor="let pid of player_ids">
                            <th *ngIf="deletePlayerEnabled">
                                <input type="checkbox" [(ngModel)]="pid.delete" value="1" />
                            </th>
                            <th>{{pid.game}}</th>
                            <td>{{pid.username}}</td>
                            <td>{{pid.game_balance}}</td>
                            <td>{{pid.status ? "Active": "Disabled"}}</td>
                            <td><a (click)="editPlayer(pid)">
                                    <svg role="button" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        fill="#000" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                                    </svg>
                                </a></td>
                        </tr>
                        <tr *ngIf="player_ids.length == 0">
                            <th colspan="4">No Game Player ID</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card rounded-0">
            <div class="card-header">
                <h2 class="card-title mb-0">Player Game ID</h2>
            </div>
            <div class="card-body">
                <form #playerForm="ngForm" (ngSubmit)="playerForm.valid && updatePlayerGameID()" novalidate>
                    <div class="mb-3">
                        <label for="game_id" class="form-label">Game <em>*</em></label>
                        <select class="form-control" name="game_id" #game_id="ngModel"
                            [(ngModel)]="player_id_data.game_id" required [disabled]="player_id_data.integration_id">
                            <option [value]="g.id" *ngFor="let g of games;">{{g.title}} (RM {{g.balance}})</option>
                        </select>
                        <div *ngIf="playerForm.submitted && game_id.invalid" class="invalid-feedback">
                            <div *ngIf="game_id.errors.required">Game is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="username" class="form-label">Player Game Username <em>*</em></label>
                        <input type="text" maxlength="20" minlength="3" class="form-control" id="username"
                            name="username" #username="ngModel" [(ngModel)]="player_id_data.username" required
                            [disabled]="player_id_data.integration_id">
                        <div *ngIf="playerForm.submitted && username.invalid" class="invalid-feedback">
                            <div *ngIf="username.errors.required">Player Game ID is required.</div>
                            <div *ngIf="username.errors.minlength">Player Game ID minimun length is 3.</div>
                            <div *ngIf="username.errors.maxlength">Player Game ID maximum length is 20.</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label">Player Game Password</label>
                        <input type="password" maxlength="20" minlength="3" class="form-control" id="password"
                            name="password" #password="ngModel" [(ngModel)]="player_id_data.password">
                        <div *ngIf="playerForm.submitted && password.invalid" class="invalid-feedback">
                            <div *ngIf="password.errors.minlength">Player Game ID minimun length is 3.</div>
                            <div *ngIf="password.errors.maxlength">Player Game ID maximum length is 20.</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="player_id_data.status"
                            required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                            <option *ngIf="!player_id_data.integration_id" [value]="99">Delete</option>
                        </select>
                        <div *ngIf="playerForm.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>
                    <div class="d-flex flex-row">
                        <button type="submit" class="btn btn-primary">
                            <span *ngIf="!player_id_data.id">Add</span>
                            <span *ngIf="player_id_data.id">Update</span> Player Game ID
                        </button>
                        <button class="ms-1 btn btn-outline-primary" *ngIf="player_id_data.id" (click)="clearPlayer()">
                            Clear
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card rounded-0">
            <div class="card-header">
                <h2 class="card-title mb-0">Transaction</h2>
            </div>
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && updateTransaction()" novalidate>
                    <div class="mb-3">
                        <label for="type" class="form-label">Type <em>*</em></label>
                        <select class="form-control" name="type" #type="ngModel" [(ngModel)]="transaction.type"
                            (change)="initTransctionForm()" required>
                            <!-- <ng-container *ngIf="permission.game_integration">
                                <optgroup label="API Integration">
                                    <option [value]="'auto-topup'">Auto Topup</option>
                                    <option [value]="'auto-withdraw'">Auto Withdraw</option>
                                    <option [value]="'auto-check-balance'">Check Balance</option>
                                </optgroup>
                            </ng-container> -->
                            <optgroup label="Manual">
                                <option [value]="'topup'">Topup</option>
                                <option [value]="'withdraw'">Withdraw</option>
                                <option [value]="'withdraw-commission'">Withdraw Commission</option>
                                <option [value]="'withdraw-credit'">Withdraw Credit</option>
                            </optgroup>
                            <!-- <option [value]="'transfer'">Transfer (Game to Game)</option> -->
                            <!-- <option [value]="'transfer-to-game'">Wallet to Game</option>
                            <option [value]="'transfer-to-wallet'">Game to Wallet</option> -->
                            <ng-container *ngIf="permission.can_manage">
                                <optgroup label="Adjustment">
                                    <option [value]="'commission-adjustment'">Commission Adjustment</option>
                                    <!-- <option [value]="'wallet-adjustment'" >Wallet Adjustment</option> -->
                                    <option [value]="'profit-adjustment'">Profit Adjustment</option>
                                </optgroup>
                            </ng-container>
                        </select>
                        <div *ngIf="f.submitted && type.invalid" class="invalid-feedback">
                            <div *ngIf="type.errors.required">Type is required</div>
                        </div>
                    </div>

                    <ng-container *ngIf="transaction.type == 'withdraw-commission'">
                        <div class="mb-3">
                            <label for="bank" class="form-label">From Bank <em>*</em></label>
                            <select class="form-control" name="bank" #bank="ngModel" [(ngModel)]="transaction.bank"
                                required>
                                <option [value]="b.id" *ngFor="let b of banks;">{{b.title}} (RM {{b.balance}})</option>
                            </select>
                            <div *ngIf="f.submitted && bank.invalid" class="invalid-feedback">
                                <div *ngIf="bank.errors.required">Bank is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="payment" class="form-label">Commission Payout <em>*</em></label>
                            <input type="number" class="form-control" id="payment" name="payment" #payment="ngModel"
                                [(ngModel)]="transaction.payment" (blur)="checkIfNegative()" required>
                            <div *ngIf="f.submitted && payment.invalid" class="invalid-feedback">
                                <div *ngIf="payment.errors.required">Commission Payout is required</div>
                            </div>
                        </div>

                        <div class="mb-3" *ngIf="data.banks.length > 0">
                            <hr />
                            <p>Select from customer account or manual fill in below</p>
                            <label for="payout_account" class="form-label">Payout To Account</label>

                            <select class="form-control" id="payout_account" name="payout_account"
                                #payout_account="ngModel" [(ngModel)]="transaction.payout_account">
                                <option value="-">New Account</option>
                                <option *ngFor="let bank of data.banks" [value]="bank.id">{{bank.bank}} -
                                    {{bank.account}}</option>
                            </select>

                            <div class="input-group mt-3"
                                *ngIf="setting.enabled_finance_charge === 'true' && setting.finance_charge_rate">
                                <div class="input-group-append flex-fill">
                                    <div class="input-group-text">
                                        <label class="me-2" for="finance_charge">Finance Charge</label>
                                        <select [(ngModel)]="transaction.finance_charge" #fc="ngModel"
                                            id="finance_charge" name="finance_charge" (change)="fcRateChange()"
                                            required>
                                            <option [value]="true">YES</option>
                                            <option [value]="false">No</option>
                                        </select>
                                    </div>
                                    <div *ngIf="f.submitted && fc.invalid" class="invalid-feedback">
                                        <div *ngIf="fc.errors.required">Finance Charge is required</div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="f.submitted && payout_account.invalid" class="invalid-feedback">
                                <div *ngIf="payout_account.errors.required">Payout To Account is required</div>
                            </div>

                            <div class="mt-3"
                                *ngIf="setting.enabled_finance_charge === 'true' && setting.finance_charge_rate && transaction.payment && transaction.finance_charge === 'true'">
                                Final Bank Transaction:<br />{{transaction.payment ?? 0}} +
                                {{setting.finance_charge_rate}} = <span
                                    class="text-danger fw-bolder">{{(transaction.payment ?? 0) +
                                    setting.finance_charge_rate}}</span>
                            </div>
                            <hr *ngIf="transaction.payout_account == '-'" />
                            <!--                             
                            <label for="payout_account" class="form-label">Payout To Account</label>
                            <div class="input-group">
                                <div class="input-group-append">
                                  <div class="input-group-text">
                                    <label class="me-2" for="fc">Finance Charge</label>
                                    <input type="checkbox" id="fc" />
                                </div>
                                </div>
                                <select class="form-control" id="payout_account" name="payout_account" #payout_account="ngModel" [(ngModel)]="transaction.payout_account" >
                                    <option value="-">-</option>
                                    <option *ngFor="let bank of data.banks" [value]="bank.id">{{bank.bank}} - {{bank.account}}</option>
                                </select>
                            </div>
                            
                            <div *ngIf="f.submitted && payout_account.invalid" class="invalid-feedback">
                                <div *ngIf="payout_account.errors.required">Payout To Account is required</div>
                            </div>
                            <hr/>
                            <p>Select from option above or manual fill in below</p> -->
                        </div>
                        <div class="mb-3" *ngIf="(transaction.payout_account == '-' && transaction.payout_account)">
                            <label for="payment_bank" class="form-label">Payment to Bank</label>
                            <input type="text" class="form-control" id="payment_bank" name="payment_bank"
                                #payment_bank="ngModel" [(ngModel)]="transaction.payment_bank">
                            <div *ngIf="f.submitted && payment_bank.invalid" class="invalid-feedback">
                                <div *ngIf="payment_bank.errors.required">Bank is required</div>
                            </div>
                        </div>
                        <div class="mb-3" *ngIf="(transaction.payout_account == '-' && transaction.payout_account)">
                            <label for="bank_account" class="form-label">Payment to Account</label>
                            <input type="number" class="form-control" id="bank_account" name="bank_account"
                                #bank_account="ngModel" [(ngModel)]="transaction.bank_account">
                            <div *ngIf="f.submitted && bank_account.invalid" class="invalid-feedback">
                                <div *ngIf="bank_account.errors.required">Bank Account is required</div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="transaction.type == 'auto-topup'">
                        <div>
                            select integration<br />
                            select user id / create a new user<br />
                            topup value
                        </div>
                    </ng-container>

                    <ng-container *ngIf="transaction.type == 'auto-withdraw'">
                        <div>
                            select integration<br />
                            select user id<br />
                            auto withdraw all the balance
                        </div>
                    </ng-container>

                    <ng-container *ngIf="transaction.type == 'auto-check-balance'">
                        <div>
                            select integration<br />
                            select user id
                        </div>
                    </ng-container>

                    <ng-container *ngIf="transaction.type == 'withdraw-credit'">

                        <div class="mb-3">
                            <label for="payment" class="form-label">Credit Payout / Withdraw <em>*</em></label>
                            <input type="number" class="form-control" id="payment" name="payment" #payment="ngModel"
                                [(ngModel)]="transaction.payment" (blur)="checkIfNegative()" required>
                            <div *ngIf="f.submitted && payment.invalid" class="invalid-feedback">
                                <div *ngIf="payment.errors.required">Commission Payout is required</div>
                            </div>
                        </div>

                    </ng-container>

                    <ng-container *ngIf="transaction.type == 'commission-adjustment'">
                        <div class="mb-3">
                            <label for="commission_value" class="form-label">Commission Value <em>*</em></label>
                            <input type="number" class="form-control" id="commission_value" name="commission_value"
                                #commission_value="ngModel" [(ngModel)]="transaction.commission_value"
                                (blur)="checkIfNegative()" required>
                            <div *ngIf="f.submitted && commission_value.invalid" class="invalid-feedback">
                                <div *ngIf="commission_value.errors.required">Commission Value is required</div>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label for="adjustment_type" class="form-label">Adjustment Type</label>
                            <select class="form-control" id="adjustment_type" name="adjustment_type"
                                #adjustment_type="ngModel" [(ngModel)]="transaction.adjustment_type">
                                <option value="add">Add Commission</option>
                                <option value="deduct">Deduct Commission</option>
                                <option value="balance">Set Commission Balance</option>
                            </select>
                        </div>

                        <div class="mb-3">
                            <label for="remark" class="form-label">Commission Remark <em>*</em></label>
                            <input type="text" class="form-control" id="remark" name="remark" #remark="ngModel"
                                [(ngModel)]="transaction.remark" required>
                            <div *ngIf="f.submitted && remark.invalid" class="invalid-feedback">
                                <div *ngIf="remark.errors.required">Adjustment Remark is required</div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="transaction.type == 'topup' || transaction.type == 'withdraw'">
                        <div class="mb-3">
                            <label for="bank" class="form-label">From Bank <em>*</em></label>
                            <select class="form-control" name="bank" #bank="ngModel" [(ngModel)]="transaction.bank"
                                required>
                                <option [value]="b.id" *ngFor="let b of banks;">{{b.title}} (RM {{b.balance}})</option>
                            </select>
                            <div *ngIf="f.submitted && bank.invalid" class="invalid-feedback">
                                <div *ngIf="bank.errors.required">Bank is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="payment" class="form-label">Payment {{transaction.type == 'topup' ?
                                "Recevied":"Payout"}} <em>*</em></label>
                            <input type="number" class="form-control" id="payment" name="payment" #payment="ngModel"
                                [(ngModel)]="transaction.payment" (input)="calculateReferral()" required>
                            <div *ngIf="f.submitted && payment.invalid" class="invalid-feedback">
                                <div *ngIf="payment.errors.required">Payment {{transaction.type == 'topup' ?
                                    "Recevied":"Payout"}} is required</div>
                            </div>
                        </div>

                        <div class="mb-3" *ngIf="transaction.type == 'topup' && data.referral_id">
                            <label for="referral_commission" class="form-label">Referral Commission</label>
                            <input type="text" class="form-control" id="referral_commission" name="referral_commission"
                                #referral_commission="ngModel" [(ngModel)]="transaction.referral_commission" readonly>
                        </div>

                        <div class="mb-3" *ngIf="transaction.type == 'withdraw' && data.banks.length > 0">
                            <hr />
                            <p>Select from customer account or manual fill in below</p>
                            <label for="payout_account" class="form-label">Payout To Account</label>

                            <select class="form-control" id="payout_account" name="payout_account"
                                #payout_account="ngModel" [(ngModel)]="transaction.payout_account">
                                <option value="-">New Account</option>
                                <option *ngFor="let bank of data.banks" [value]="bank.id">{{bank.bank}} -
                                    {{bank.account}}</option>
                            </select>

                            <div class="input-group mt-3"
                                *ngIf="setting.enabled_finance_charge === 'true' && setting.finance_charge_rate">
                                <div class="input-group-append flex-fill">
                                    <div class="input-group-text">
                                        <label class="me-2" for="finance_charge">Finance Charge</label>
                                        <select [(ngModel)]="transaction.finance_charge" #fc="ngModel"
                                            id="finance_charge" name="finance_charge" (change)="fcRateChange()"
                                            required>
                                            <option [value]="true">YES</option>
                                            <option [value]="false">No</option>
                                        </select>
                                    </div>
                                    <div *ngIf="f.submitted && fc.invalid" class="invalid-feedback">
                                        <div *ngIf="fc.errors.required">Finance Charge is required</div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="f.submitted && payout_account.invalid" class="invalid-feedback">
                                <div *ngIf="payout_account.errors.required">Payout To Account is required</div>
                            </div>

                            <div class="mt-3"
                                *ngIf="setting.enabled_finance_charge === 'true' && setting.finance_charge_rate && transaction.payment && transaction.finance_charge === 'true'">
                                Final Bank Transaction:<br />{{transaction.payment ?? 0}} +
                                {{setting.finance_charge_rate}} = <span
                                    class="text-danger fw-bolder">{{(transaction.payment ?? 0) +
                                    setting.finance_charge_rate}}</span>
                            </div>
                            <hr *ngIf="transaction.payout_account == '-'" />
                        </div>
                        <div class="mb-3"
                            *ngIf="transaction.type == 'withdraw' && (transaction.payout_account == '-' && transaction.payout_account)">
                            <label for="payment_bank" class="form-label">Payment to Bank</label>
                            <input type="text" class="form-control" id="payment_bank" name="payment_bank"
                                #payment_bank="ngModel" [(ngModel)]="transaction.payment_bank">
                            <div *ngIf="f.submitted && payment_bank.invalid" class="invalid-feedback">
                                <div *ngIf="payment_bank.errors.required">Bank is required</div>
                            </div>
                        </div>
                        <div class="mb-3"
                            *ngIf="transaction.type == 'withdraw' && (transaction.payout_account == '-' && transaction.payout_account)">
                            <label for="bank_account" class="form-label">Payment to Account</label>
                            <input type="number" class="form-control" id="bank_account" name="bank_account"
                                #bank_account="ngModel" [(ngModel)]="transaction.bank_account">
                            <div *ngIf="f.submitted && bank_account.invalid" class="invalid-feedback">
                                <div *ngIf="bank_account.errors.required">Bank Account is required</div>
                            </div>
                        </div>
                        <hr />
                        <div class="mb-3">
                            <label for="player_game_id" class="form-label">Player Game ID <em>*</em></label>
                            <select class="form-control" name="player_game_id" #player_game_id="ngModel"
                                [(ngModel)]="transaction.player_game_id" required>
                                <option [value]="b.id" *ngFor="let b of active_player_ids;">{{b.game}} ({{b.username}})
                                    | {{b.game_balance}}</option>
                            </select>
                            <div *ngIf="f.submitted && player_game_id.invalid" class="invalid-feedback">
                                <div *ngIf="player_game_id.errors.required">Player Game ID is required</div>
                            </div>
                            <p class="mt-2" *ngIf="!transaction.player_game_id">Without selecting the player game id,
                                topup will only added credit to / withdraw will only deduct credit from player wallet
                                only. It will not reflect in games and user games data.</p>
                        </div>
                        <div class="mb-3" *ngIf="transaction.player_game_id && transaction.type == 'topup'">
                            <label for="bonus" class="form-label">Bonus</label>
                            <input type="number" class="form-control" id="bonus" name="bonus" #bonus="ngModel"
                                [(ngModel)]="transaction.bonus" />
                        </div>
                        <div class="mb-3" *ngIf="transaction.player_game_id && transaction.type == 'topup'">
                            <label class="form-label">Player game balance after topup</label>
                            <input type="number" class="form-control"
                                [value]="transaction.payment + (transaction.bonus && transaction.bonus > 0 ? transaction.bonus : 0)"
                                readonly="readonly" />
                        </div>
                        <div class="mb-3" *ngIf="transaction.player_game_id && transaction.type == 'withdraw'">
                            <label for="game_balance" class="form-label">Player game balance after withdraw</label>
                            <input type="number" class="form-control" id="game_balance" name="game_balance"
                                #game_balance="ngModel" [value]="'0'" [(ngModel)]="transaction.game_balance" />
                        </div>
                        <div class="mb-3">
                            <label for="tips" class="form-label">Tips</label>
                            <input type="number" class="form-control" id="tips" name="tips" #tips="ngModel"
                                [(ngModel)]="transaction.tips" />
                        </div>
                        <div class="mb-3">
                            <label for="point" class="form-label">Point (+/-)</label>
                            <input type="number" class="form-control" id="point" name="point" #point="ngModel"
                                [(ngModel)]="transaction.point"
                                [readonly]="setting.credit_calculation_method && setting.credit_calculation_method == 'auto'" />
                        </div>
                        <div class="mb-3" *ngIf="transaction.type == 'topup'">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="is_advance" name="is_advance"
                                    [(ngModel)]="transaction.is_advance" />
                                <label class="form-check-label" for="is_advance">As Credit / Advance
                                    <small class="text-muted d-block">Money fronted into the wallet (not a real player deposit) — excluded from the agent loss / commission basis.</small>
                                </label>
                            </div>
                        </div>
                        <div class="mb-3" *ngIf="transaction.type == 'topup'">
                            <label class="form-label">Total Bank Received</label>
                            <input type="number" class="form-control"
                                [value]="transaction.payment + (transaction.tips && transaction.tips > 0 ? transaction.tips : 0)"
                                readonly="readonly" />
                        </div>
                        <hr *ngIf="show_generate_code" />
                        <div class="mb-3" *ngIf="show_generate_code">
                            <label for="generate_voucher_code" class="form-label">Generate Voucher Code
                                <em>*</em></label>
                            <select class="form-control" name="generate_voucher_code" #generate_voucher_code="ngModel"
                                [(ngModel)]="transaction.generate_voucher_code" (change)="generateVoucherCode()"
                                required>
                                <option [value]="false">No</option>
                                <option [value]="true">Yes</option>
                            </select>
                        </div>
                        <div class="mb-3" *ngIf="show_generate_code && transaction.generate_voucher_code === 'true'">
                            <label for="voucher_value" class="form-label">Voucher Value <em>*</em></label>
                            <select class="form-control" name="voucher_value" #voucher_value="ngModel"
                                [(ngModel)]="transaction.voucher_value" required>
                                <option *ngFor="let section of sections" [value]="section.value">{{section.label}}
                                </option>
                            </select>
                        </div>
                        <div class="mb-3" *ngIf="show_generate_code && transaction.generate_voucher_code === 'true'">
                            <label class="form-label">Voucher Code <em>*</em></label>
                            <input type="text" class="form-control" id="voucher_code" name="voucher_code"
                                #voucher_code="ngModel" [(ngModel)]="transaction.voucher_code" />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="transaction.type == 'transfer'">
                        <div class="mb-3">
                            <label for="from_game" class="form-label">From Game <em>*</em></label>
                            <select class="form-control" name="from_game" #from_game="ngModel"
                                [(ngModel)]="transaction.from_game" required>
                                <option [value]="b.id" *ngFor="let b of active_player_ids;">{{b.game}} ({{b.username}})
                                    | {{b.game_balance}}</option>
                            </select>
                            <div *ngIf="f.submitted && from_game.invalid" class="invalid-feedback">
                                <div *ngIf="from_game.errors.required">From Game is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="from_balance" class="form-label">Game Balance After Transfer <em>*</em></label>
                            <input type="number" class="form-control" id="from_balance" name="from_balance"
                                #from_balance="ngModel" [(ngModel)]="transaction.from_balance" required>
                            <div *ngIf="f.submitted && from_balance.invalid" class="invalid-feedback">
                                <div *ngIf="from_balance.errors.required">Point to Transfer is required</div>
                            </div>
                        </div>
                        <hr />
                        <div class="mb-3">
                            <label for="to_game" class="form-label">To Game <em>*</em></label>
                            <select class="form-control" name="to_game" #to_game="ngModel"
                                [(ngModel)]="transaction.to_game" required>
                                <option [value]="b.id" *ngFor="let b of active_player_ids;">{{b.game}} ({{b.username}})
                                    | {{b.game_balance}}</option>
                            </select>
                            <div *ngIf="f.submitted && to_game.invalid" class="invalid-feedback">
                                <div *ngIf="to_game.errors.required">To Game is required</div>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label for="transfer" class="form-label">Game Point to Transfer <em>*</em></label>
                            <input type="number" class="form-control" id="transfer" name="transfer" #transfer="ngModel"
                                [(ngModel)]="transaction.transfer" required>
                            <div *ngIf="f.submitted && transfer.invalid" class="invalid-feedback">
                                <div *ngIf="transfer.errors.required">Game Point to Transfer is required</div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="transaction.type == 'transfer-to-wallet'">
                        <div class="mb-3">
                            <label for="game" class="form-label">From Game <em>*</em></label>
                            <select class="form-control" name="game" #game="ngModel" [(ngModel)]="transaction.game"
                                required>
                                <option [value]="b.id" *ngFor="let b of active_player_ids;">{{b.game}} ({{b.username}})
                                    | {{b.game_balance}}</option>
                            </select>
                            <div *ngIf="f.submitted && game.invalid" class="invalid-feedback">
                                <div *ngIf="game.errors.required">Game is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="wallet" class="form-label">To Player Wallet<em>*</em></label>
                            <input type="number" class="form-control" id="wallet" name="wallet" #wallet="ngModel"
                                [(ngModel)]="transaction.wallet" required>
                            <div *ngIf="f.submitted && wallet.invalid" class="invalid-feedback">
                                <div *ngIf="wallet.errors.required">Wallet value is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="from_balance" class="form-label">Game Balance After Transfer <em>*</em></label>
                            <input type="number" class="form-control" id="from_balance" name="from_balance"
                                #from_balance="ngModel" [(ngModel)]="transaction.from_balance" required>
                            <div *ngIf="f.submitted && from_balance.invalid" class="invalid-feedback">
                                <div *ngIf="from_balance.errors.required">Game balance after transfer is required</div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="transaction.type == 'transfer-to-game'">
                        <div class="mb-3">
                            <label for="wallet" class="form-label">From Player Wallet<em>*</em></label>
                            <input type="number" class="form-control" id="wallet" name="wallet" #wallet="ngModel"
                                [(ngModel)]="transaction.wallet" required>
                            <div *ngIf="f.submitted && wallet.invalid" class="invalid-feedback">
                                <div *ngIf="wallet.errors.required">Wallet value is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="game" class="form-label">To Game<em>*</em></label>
                            <select class="form-control" name="game" #game="ngModel" [(ngModel)]="transaction.game"
                                required>
                                <option [value]="b.id" *ngFor="let b of active_player_ids;">{{b.game}} ({{b.username}})
                                    | {{b.game_balance}}</option>
                            </select>
                            <div *ngIf="f.submitted && game.invalid" class="invalid-feedback">
                                <div *ngIf="game.errors.required">Game is required</div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="transaction.type == 'wallet-adjustment'">
                        <div class="mb-3">
                            <label for="method" class="form-label">Type<em>*</em></label>
                            <select class="form-control" name="method" #method="ngModel"
                                [(ngModel)]="transaction.method" required>
                                <option [value]="'debit'">Debit (+)</option>
                                <option [value]="'credit'">Credit (-)</option>
                            </select>
                            <div *ngIf="f.submitted && type.invalid" class="invalid-feedback">
                                <div *ngIf="type.errors.required">Type is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="adjustment" class="form-label">Adjustment Value<em>*</em></label>
                            <input type="number" class="form-control" id="adjustment" name="adjustment"
                                #adjustment="ngModel" [(ngModel)]="transaction.adjustment" required>
                            <div *ngIf="f.submitted && adjustment.invalid" class="invalid-feedback">
                                <div *ngIf="adjustment.errors.required">Adjustment value is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="remark" class="form-label">Remark</label>
                            <input type="text" class="form-control" id="remark" name="remark" #remark="ngModel"
                                [(ngModel)]="transaction.remark" maxlength="100">
                        </div>
                    </ng-container>
                    <ng-container *ngIf="transaction.type == 'profit-adjustment'">
                        <div class="mb-3">
                            <label for="method" class="form-label">Type<em>*</em></label>
                            <select class="form-control" name="method" #method="ngModel"
                                [(ngModel)]="transaction.method" required>
                                <option [value]="'debit'">Debit (+)</option>
                                <option [value]="'credit'">Credit (-)</option>
                            </select>
                            <div *ngIf="f.submitted && type.invalid" class="invalid-feedback">
                                <div *ngIf="type.errors.required">Type is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="adjustment" class="form-label">Adjustment Value<em>*</em></label>
                            <input type="number" class="form-control" id="adjustment" name="adjustment"
                                #adjustment="ngModel" [(ngModel)]="transaction.adjustment" required>
                            <div *ngIf="f.submitted && adjustment.invalid" class="invalid-feedback">
                                <div *ngIf="adjustment.errors.required">Adjustment value is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="remark" class="form-label">Remark</label>
                            <input type="text" class="form-control" id="remark" name="remark" #remark="ngModel"
                                [(ngModel)]="transaction.remark" maxlength="100">
                        </div>
                        <div class="mb-3">
                            <label for="adjustment" class="form-label">Profit Balance</label>
                            <input type="number" class="form-control"
                                [value]="((summary.profit * 1) + (transaction.method == 'debit' ? transaction.adjustment : -1 * transaction.adjustment))"
                                readonly />
                        </div>
                    </ng-container>
                    <button type="submit" class="btn btn-primary" [disabled]="transaction_loading">Add
                        Transaction</button>
                </form>
            </div>
        </div>
    </div>

</div>
</fieldset>
